define([
  'app/modules/map',
  'app/modules/shorten',
  'app/control/uploader',
  'app/modules/forms',
  'app/modules/activity',
  'app/modules/job',
  'app/modules/utilities',
  'app/modules/tabs',
  'vendor/material.min.js',
  'scriptjs',
  'app/modules/location_manager',
  'app/modules/applicant_upload_modal',
  'app/modules/filteringList',
  'app/modules/company-grid'
], function(googleMap, Shorten, Uploader, Forms, Activity, Job, Util, Tabs, mdl, $script, LocationManager, ApplicantUploadModal, FilteringList, companyGrid) {
  var currentMap = null;
  var Companies = function () { };

  var headerCtrl = function (header_class_name) {
    "use strict";
    var sectionHeaders = document.getElementsByClassName(header_class_name);
    var headerContainer = document.getElementsByClassName('header');
    var headerH = 0;

    if(sectionHeaders.length > 0) {
      sectionHeaders = sectionHeaders[0];
    }

    if(headerContainer.length > 0) {
      headerContainer = headerContainer[0];
    }
    var last_known_scroll_position = window.scrollY || window.pageYOffset || document.body.scrollTop + (document.documentElement && document.documentElement.scrollTop || 0);
    var ticking = false;
    headerH = sectionHeaders.offsetHeight - headerContainer.offsetHeight;
    updateHeader(last_known_scroll_position);

    var onScrolling = function (ev) {
      last_known_scroll_position = window.scrollY || window.pageYOffset || document.body.scrollTop + (document.documentElement && document.documentElement.scrollTop || 0);

      if (!ticking) {
        window.requestAnimationFrame(function() {
          updateHeader(last_known_scroll_position);
          ticking = false;
        });
      }
      ticking = true;
    };
    document.onscroll = onScrolling;

    function updateHeader(scroll_pos) {
      var initialColor = headerContainer.getAttribute('data-attr-color');
      if(scroll_pos >= headerH ) {
        headerContainer.style.backgroundColor = initialColor + '1)';
      }
      else if(scroll_pos > 0 && scroll_pos < headerH) {
        headerContainer.style.backgroundColor = initialColor + 1*scroll_pos/headerH +')';
      }
      else {
        headerContainer.style.backgroundColor = initialColor + '0)';
      }
    }
  };

  Companies.prototype.actionShow_standalone = function() {
    headerCtrl('company-header');

    $(".scrollTo").click(function(event) {
      event.preventDefault();

      var defaultAnchorOffset = 60;

      var anchor = $(this).attr('data-attr-scroll');

      var anchorOffset = $('#'+anchor).attr('data-scroll-offset');
      if (!anchorOffset)
        anchorOffset = defaultAnchorOffset;

      $('html,body').animate({
        scrollTop: $('#'+anchor).offset().top - anchorOffset
      }, 500);
    });

    $('.activity-list a').on('click', function(){
      $('.activity-list a li').removeClass('active ca-override__background-color ca-override__border-color ca-override__border-left-color__after');
      $(this).find('li').addClass('active ca-override__background-color ca-override__border-color ca-override__border-left-color__after');
    });

    $('.member-read-more').on('click', function() {
      var target = $(this).parent().find('.member-description');
      target.height();
      if (target.hasClass('show-less')) {
        target.removeClass('show-less');
        $(this).text('Close');
      } else {
        target.addClass('show-less');
        $(this).text('Read more');
      }
    });

    this.initStandaloneFilter();
    this.initSliders();
    this.renderMaps();
  };

  Companies.prototype.initSliders = function() {
    var $sliders = $(".js-slider");

    $sliders.each(function(idx, slider) {
      $(slider).slick({
        slidesToScroll: 1,
        dots: true,
        responsive: [
          {
            breakpoint: 768,
            settings: { slidesToShow: 1 }
          }
        ]
      });
    });
  };

  Companies.prototype.renderMaps = function() {
    var $maps = $('.js-maps');
    var self = this;

    $script.ready('google-maps', function() {
      $maps.each(function(idx, map) {
        self.renderMap(map);
      });
    });
  };

  Companies.prototype.initStandaloneFilter = function() {
    var $filter = $('.js-dropdowns-filter');
    var $list = $('.js-dropdowns-filter-list');

    $filter.find('ul li').on('click', function() {
      Job.careersFilter({ $filter: $filter, $el: $(this), $list: $list, params: { standalone: true } });
    });
  }

  Companies.prototype.actionShow = function() {
    var self = this;
    $('.shorten').not('.shorten-init').each(function(){
      Shorten.init($(this));
    });

    var mainTabs = new Tabs();

    $('.jobs-list').on('click', '.job-item .close-job', function(e){
      e.preventDefault();
      Job.close($(this).parents('.job-item'));
    });

    $script.ready('google-maps',function() {
      var mapCanvas = document.getElementById('map');

      if (mapCanvas) {
        self.renderMap(mapCanvas);
      }

      mainTabs.$event.on('shown.tabs', function (evn, data) {
        if (data && data.tab_id) {
          var tab = document.getElementById(data.tab_id.replace('#', ''));
          var nodes = tab.getElementsByClassName('ca-js-card');

          for (var i = 0; i < nodes.length; i++) {
            mdl.downgradeElements(nodes[i]);
            mdl.upgradeElement(nodes[i]);
          }
        }
      });
    });

    new FilteringList({
      withoutHistoryUpdating: true,
      onSuccess: function(result){
        if(result.jobs_html){
          $('.js-filtering-list').html(result.jobs_html);
        }
      }
    });

    this.initCompanyGrid();
  };

  Companies.prototype.renderMap = function(el) {
    var $el = $(el);
    var lat = $el.data('lat');
    var lon = $el.data('lon');
    var offices = $el.data('offices');

    googleMap.init(el, { zoom: 12, lat: lat, lon: lon }).then(map => {
      currentMap = map
      googleMap.addMarker(map, {
        lat: lat,
        lon: lon,
        infoWindow: {
          title: $el.data('address')
        }
      });

      if (offices && offices.length) {
        offices.forEach(function (office) {
          if (office.lat && office.lon) {

            googleMap.addMarker(map, {
              lat: office.lat,
              lon: office.lon,
              infoWindow: {
                title: office.street
              }
            });
          }
        });
      }
    })
  };

  Companies.prototype.initCompanyGrid = function() {
    var $grid = $('.js-company-masonry-grid');
    var $spinner = $('.js-company-spinner')

    companyGrid.randomizeElements({
      $el: $grid,
      itemSelector: '.js-company-grid-item'
    });

    $grid.addClass('is-visible');
  };

  Companies.prototype.actionEdit = function(){
    var uplCoverPicture = new Uploader($('#company_cover_picture_uploader'), {type: 'image', autoUpload: true, field_name: 'Cover Picture'});
    var uplLogo = new Uploader($('#company_logo_uploader'), {type: 'image', autoUpload: true, field_name: 'Logo'});
    var uplDescImage = new Uploader($('#company_desc_image_uploader'), {type: 'image', autoUpload: true, field_name: 'Photo'});
    var uplInfluencerAvatar = new Uploader($('#company_influencer_avatar_uploader'), {type: 'image', autoUpload: true, field_name: 'Photo'});
    var uplInfluencerImage = new Uploader($('#company_influencer_image_uploader'), {type: 'image', autoUpload: true, field_name: 'Photo'});
    new Uploader($('#disclaimer_uploader'), { type: 'file', autoUpload: true });

    $script.ready('google-maps',function() {
      var geocoder, map;

      var updateLocations = function () {
        setTimeout(function () {
          var geocoder_office = new google.maps.Geocoder();
          $('.company-office-form .office').each(function () {
            googleMap.init($(this).find('.photo-column div')[0]).then(map => {
              currentMap = map;
              var address = LocationManager.getCompanyOfficeAddress($(this).find('.list-column .content'));
              if (address == '') return;
              googleMap.geoLocate(geocoder_office, address, map);
            })
          });
        }, 200);
      };

      $('a[href="#locations"]').on('shown.bs.tab', function () {
        updateLocations();
      });

      $('a[data-toggle="tab"]').on('shown.bs.tab', function (e) {
        if ($(e.target).attr("href") == '#headquarters') {
          setTimeout(function () {
            geocoder = new google.maps.Geocoder();
            googleMap.init(document.getElementById('map-main-office-canvas')).then(map => {
              currentMap = map;
              var address = LocationManager.getHeadquartersAddress($('#headquarters .content'));
              googleMap.geoLocate(geocoder, address, map);
            })
          }, 200);
        }
      });

      $('#overviewSections').on('submit', '.company-headquarters-form', function(e) {
        e.preventDefault();
        Forms.submit($(this), 'company_', function(data, form){
          var address = LocationManager.getHeadquartersAddress($('#headquarters .content'));
          LocationManager.setHeadquartersCoords(geocoder, address, currentMap, form, data);
        });
      });

      $('#activitiesSections').on('submit', '.activity-form', function(e){
        e.preventDefault();
        Activity.update($(this), 'activity_');
      }).on('click', '.remove-activity', function(e){
        e.preventDefault();
        Activity.destroy($(this));
      });

      $('.tab-content #locations').on('nested:fieldAdded', function(e) {
        $(e.field).find('.chosen-select-with-search').chosen({
          disable_search_threshold: 10,
          width: "100%",
          allow_single_deselect: true
        });
        updateLocations();
      });

      $('#overviewSections').on('submit', '.company-office-form', function(e) {
        e.preventDefault();
        Forms.submit($(this), 'company_', function(data, form){
          Forms.showSuccess(data);
          form.parent().html(data.offices_html);
          var form = $('.company-office-form');
          LocationManager.updateCompanyLocations(form, data);
          form.find('.chosen-select-with-search').chosen({
            disable_search_threshold: 10,
            width: "100%",
            allow_single_deselect: true
          });
          updateLocations();
        });
      });

      $('#overviewSections').on('submit', '.company-settings-form', function(e) {
        e.preventDefault();
        Forms.submit($(this), 'company_', function(data, form){
          Forms.showSuccess(data);
        });
      });
    });

    $('.tab-content #team').on('nested:fieldAdded', function(e) {
      console.log(e);
      $(e.field).find('.team-member-photo-uploader').each(function(){
        new Uploader($(this), {type: 'image', autoUpload: true, field_name: 'Photo'});
      });
      $(e.field).find('input.radio-icheck').iCheck({ handle: 'radio' });
    });

    $('.tab-content #media').on('nested:fieldAdded', function(e) {
      $(e.field).find('.media-desc-image-uploader').each(function(){
        new Uploader($(this), {type: 'image', autoUpload: true, field_name: 'Photo'});
      });
      $(e.field).find('input.radio-icheck').iCheck({ handle: 'radio' });
      $(e.field).find('input.radio-icheck').each(function() {
        $(this).closest('.media-upload').find('.tab-pane input').prop('disabled', !$(this).is(':checked'));
      });
    });

    $('.team-member-photo-uploader, .activity-desc-image-uploader, .media-desc-image-uploader').each(function(){
      new Uploader($(this), {type: 'image', autoUpload: true, field_name: 'Photo'});
    });

    $('#overviewSections').on('submit', '.company-team-form', function(e){
      e.preventDefault();
      Forms.submitWithFiles($(this), 'company_', function(data, form){
        Forms.nextTab(form.parent());
        form.parent().html(data.team_html);
        console.log(form.find('.team-member-photo-uploader'));
        $('.team-member-photo-uploader').each(function(){
          new Uploader($(this), {type: 'image', autoUpload: true, field_name: 'Photo'});
        });
        $('.company-team-form').find('input.radio-icheck').iCheck({ handle: 'radio' });
      });
    });

    $('#overviewSections').on('submit', '.company-programs-form', function(e){
      e.preventDefault();
      Forms.submit($(this), 'company_', function(data, form){
        form.parent().html(data.programs_html);
        Util.setMonthDateTimePicker($('.company-programs-form'));
      });
    });

    $('#overviewSections').on('submit', '.company-free-text-form', function(e){
      e.preventDefault();
      Forms.submit($(this), 'company_', function(data, form){
        Forms.nextTab(form.parent());
        form.parent().html(data.free_text_html);
      });
    });

    $('#overviewSections').on('submit', '.company-media-form', function(e){
      e.preventDefault();
      Forms.submitWithFiles($(this), 'company_', function(data, form){
        Forms.showSuccess(data);
        Forms.nextTab(form.parent());
        form.parent().html(data.media_html);
        var form = $('.company-media-form');
        form.find('.media-desc-image-uploader').each(function(){
          new Uploader($(this), {type: 'image', autoUpload: true, field_name: 'Photo'});
        });
        form.find('input.radio-icheck').iCheck({ handle: 'radio' });
        form.find('input.radio-icheck').each(function() {
          $(this).closest('.media-upload').find('.tab-pane input').prop('disabled', !$(this).is(':checked'));
        });
      });
    });

    $('#overviewSections .company-form').on('submit', function(e){
      e.preventDefault();
      Forms.submit($(this), 'company_');
    });

    $('#companyForms .panel-collapse').on('show.bs.collapse', function(){
      $('.tab-content.company-forms > .tab-pane.active').removeClass('active');
      $($(this).attr('data-tab')).addClass('active');
      $('#companyForms .panel-heading a.active').removeClass('active');
      $(this).parents('.panel').find('.panel-heading a').addClass('active');
    });

    $('.company-form-edit .tab-content .panel-collapse').on('show.bs.collapse', function(){
      $('#companyForms .section-list a[href="#'+$(this).attr('id')+'"]').addClass('active');
      $(this).parents('.panel').find('.panel-heading a').removeClass('collapsed');
    }).on('hide.bs.collapse', function(){
      $('#companyForms .section-list a.active[href="#'+$(this).attr('id')+'"]').removeClass('active');
      $(this).parents('.panel').find('.panel-heading a').addClass('collapsed');
    });

    $('#activities .add-activity').on('click', function(e){
      e.preventDefault();
      Activity.add($(this).attr('href'), function(data_html) {
        $(data_html).find('.activity-desc-image-uploader').each(function () {
          new Uploader($(this), {type: 'image', autoUpload: true, field_name: 'Photo'});
        });
      });
    });

    $('.company-image-upload').each(function(){
      Forms.initFileUpload($(this));
    });

    $('.media-upload input.radio-icheck').each(function() {
      $(this).parent().parent().parent().find('.tab-pane input').prop('disabled', !$(this).is(':checked'));
    });
    $('body').on('ifToggled', '.media-upload input.radio-icheck', function(e){
      $(this).parent().parent().parent().find('.tab-pane input').prop('disabled', !$(this).is(':checked'));
    });

    $('input#company_color').minicolors();

    $('#company_industry, #company_employees_count, #activity_industry, #company_country').chosen({
      disable_search_threshold: 10,
      width: "100%",
      allow_single_deselect: true
    });

    $('body').on('ifChanged', '.nav-tabs.change-input-type input.desc-type-radio.radio-icheck', function(){
      var tabs = $(this).parents('.change-input-type').next('.tab-content');
      Forms.changeInputType(tabs, $(this).val());
    });

    $('.nav-tabs.change-input-type input.desc-type-radio:checked').each(function(){
      var tabs = $(this).parents('.change-input-type').next('.tab-content');
      Forms.changeInputType(tabs, $(this).val());
    });
  };

  Companies.prototype.actionDashboard = function() {
    $('.jobs-list-section a')
      .not('[data-toggle="dropdown"]')
      .not('[data-method]')
      .on('click', function (e) { e.stopPropagation(); })

    var job_filter = $('.row-filter');

    $('.wrapper').collapse({toggle: false});

    job_filter.find('li').on('click', function(){
      Job.dashboardFilter({ job_filter: job_filter, el: $(this) });
    });

    var toggleSwitch = function(showSwitch, mode) {
      if (mode == 'show') {
        showSwitch.find('.fa').removeClass('fa-expand').addClass('fa-compress');
        showSwitch.find('.name').text('Hide all');
      } else {
        showSwitch.find('.fa').removeClass('fa-compress').addClass('fa-expand');
        showSwitch.find('.name').text('Expand all');
      }
    }

    $('body').on('click', '.title', function() {
      toggleSwitch($(this).parent().find('.showSwitch'), 'hide');
    });

    $('body').on('click', '.title.collapsed', function() {
      if ($(this).parent().find('.content .in').length) {
        toggleSwitch($(this).parent().find('.showSwitch'), 'show');
      }
    });

    $('body').on('shown.bs.collapse', '.wrapper', function() {
      toggleSwitch($(this).parents('.jobs-list-section').find('.showSwitch'), 'show');
    });

    $('body').on('hidden.bs.collapse', '.wrapper', function() {
      if (!$(this).parents('.content').find('.in').length) {
        toggleSwitch($(this).parents('.jobs-list-section').find('.showSwitch'), 'hide');
      }
    });

    $('body').on('click', '.showSwitch', function() {
      var jobs_section = $(this).parent();
      var switchMode = $(this).find('.fa').hasClass('fa-expand') ? 'show' : 'hide';
      jobs_section.find('.collapse-wrapper').collapse('show');
      jobs_section.find('.wrapper').collapse(switchMode);

      toggleSwitch($(this), switchMode);
    });

    ApplicantUploadModal.init();
  };

  Companies.prototype.actionPartners_board = function() {
    $('.jobs-list-section a').not('[data-toggle="dropdown"]').not('[data-method]').on('click', function (e) { e.stopPropagation(); });
    var job_filter = $('.filter-bar');
    $('.wrapper').collapse({toggle: false});
    job_filter.find('li').on('click', function(){
      Job.partnersboardFilter({job_filter: job_filter, el: $(this)});
    });
  };

  return Companies;
});
